export default __webpack_public_path__ + "static/media/Levon Abrahamyan CV.4faf85e4.pdf";